const VIDEO_BASE = "https://pub-1ee49b423fb0441183f8f72f39897cc7.r2.dev/greatleaders-academy/videos";

export const VIDEOS_TITLE = "הבוגרים שלנו מספרים";
export const VIDEOS_TITLE_LINES = ["הבוגרים שלנו", "מספרים"];

export const TAU_EXPERIENCE_TEXT =
  "הובלנו שישה קורסים בפיתוח מנהיגות (מעל 200 סטודנטים) בפקולטה לניהול באוניברסיטת תל אביב, במסלולי התואר הראשון והשני. הקורס קיבל הכרה מתמשכת וזכה בפעם השלישית ברציפות בתעודת הצטיינות של הדיקאן על המצוינות בהוראה וחדשנות.";

export const TAU_EXPERIENCE_HIGHLIGHTS = [
  { id: "courses", value: "6", label: "קורסי מנהיגות" },
  { id: "students", value: "200+", label: "סטודנטים" },
  { id: "award", value: "3×", label: "הצטיינות הדיקן" },
];
export const REVIEWS_TITLE = "מה הסטודנטים כותבים";

export const GRADUATE_VIDEOS = [
  {
    key: "video-yotam",
    src: `${VIDEO_BASE}/yotam.mp4`,
    name: "יותם אשכנזי",
    role: "בוגר קורס פיתוח מנהיגות מחזור 1",
  },
  {
    key: "video-tomer",
    src: `${VIDEO_BASE}/tomer.mp4`,
    name: "תומר",
    role: "בוגר קורס פיתוח מנהיגות מחזור 6",
  },
  {
    key: "video-daniel",
    src: `${VIDEO_BASE}/daniel.mp4`,
    name: "דניאל סרגי",
    role: "בוגר קורס פיתוח מנהיגות מחזור 5",
  },
  {
    key: "video-mor",
    src: `${VIDEO_BASE}/mor.mp4`,
    name: "מור תפארת",
    role: "בוגר קורס פיתוח מנהיגות מחזור 6",
  },
  {
    key: "video-eran",
    src: `${VIDEO_BASE}/eran.mp4`,
    name: "ערן",
    role: "בוגר קורס פיתוח מנהיגות",
  },
];

export const WRITTEN_REVIEWS = [
  [
    "אחד הקורסים הכי מעניינים ואפקטיבים שהיו לי בתואר. מהרגע שנרשמתי לMBA חיכיתי לקורס כזה, פרקטי, מתמקד ביכולות בינאישיות ומעצים אותנו הסטודנטים.",
    "ד\"ר משה קטן מדהים, פתוח, קשוב, מנחה את הקבוצה ורוקם קשרים. כבר בשיעור הראשון זכר את השמות של כולנו, והיה לו חשוב לתת לנו להתבטא ולשתף חוויות אישיות. חבל לי שאין יותר קורסים כאלו בתואר.",
    "הרגשתי שהקורס הזה תרם לי באופן אישי, חידד אצלי יכולות והבנה שנתן לי דגשים על מה לעבוד על מנת לפתח את יכולות המנהיגות שלי.",
    "שתי העבודות בקורס — הן עבודת הצוות והן העבודה האישית — נעשו במהלך הקורס, תוך כדי הלמידה שלנו. הדבר הקל עלינו מאד מבחינת ניהול זמנים וגם חיבר אותנו ישירות לחומר הנלמד באותו השבוע, והביא אותנו ליישם את הלמידה גם במחקר חיצוני (העבודה הקבוצתית) וגם בניתוח פנימי על עצמנו (העבודה האישית).",
  ],
  [
    "הקורס הזה היה ממש מיוחד ושונה משאר הקורסים שאי פעם לקחתי. משה קטן לקח אותנו לתהליך מסע פיתוח מנהיגות אישי וחלק איתנו מהניסיון הרב שלו ומעולם המחקר העדכני.",
    "הייתה הרגשה שמשה לא רק בא ללמד חומר אלא באמת דואג שכל סטודנט וסטודנט יעבור תהליך התפתחות במהלך הקורס. משה הטמיע כלים שונים אשר עזרו לנו בתהליך הזה — הוראה כריזמטית ומקצועית, דיונים מרתקים ומעשירים בכיתה, משימות ייחודיות (קיבלנו משימה לקבוע ראיון עם מנכ\"ל של ארגון לבחירה).",
    "אני מרגיש שלמדתי המון מהקורס הזה ובאמת רכשתי כלים פרקטיים שיסייעו לי במקום העבודה שלי ובחיים בכלל.",
    "בנוגע למשה קטן בתור מרצה — הורגש שגם משה ממש נהנה להעביר את הקורס וגם שיש לו ידע עשיר מאוד אותו הוא רכש גם בניסיון העסקי וגם המחקרי. העובדה שמשה הגיע מעולם העסקים תרם מאוד לקורס כי הוא תמיד סיפק דוגמאות מחייו המקצועיים אשר המחישו תיאוריות שונות וזה באמת היה מידע זהב.",
    "בנוסף לכך, משה יצר אווירה מאוד נוחה וידידותית בכיתה ועודד כל סטודנט וסטודנטית להשתתף. בזכות האווירה הזו ומשימות הקבוצתיות מאוד התגבשנו ככיתה. לסיכום, אחד הקורסים הכי טובים שלקחתי!",
  ],
  [
    "אחד הקורסים המעניינים והמועילים שהיו לי בתואר.",
    "המרצה מעולה ונגיש, ועוזר להשלים את החומר למי שהיה במילואים. יש אפליקציה שמלווה את הקורס ומאוד ישים לעשות את המטלות דרכה.",
  ],
  [
    "הקורס הזה הוא מושלם, סדנה שמביאה כלים לניהול. לפי דעתי הקורס צריך להיות חובה עבור כל הסטודנטים לניהול.",
    "המרצה משה קטן מעביר את הסדנה בצורה מושלמת, הקורס הכי טוב בתואר — מומלץ לכולם",
  ],
  [
    "הקורס בפיתוח מנהיגות היה חוויה מעניינת ומיוחדת, המתאימה גם למנהלים בתחילת דרכם וגם למנהלים מנוסים.",
    "ההערכה המרכזית שכל אחד יכול להיות מנהיג ושמנהיגות היא כישור שניתן לפתח, הייתה החידוש המשמעותי ביותר שלקחתי מהקורס. דרכי ההוראה שילבו תיאוריה ופרקטיקה באופן שתורם להבנה עמוקה וליישום מעשי של החומר.",
    "ד״ר משה הוא מרצה נעים הליכות ומעביר את הקורס בצורה שונה ומיוחדת בשונה מקורסים רגילים המועברים במסגרת אקדמית. לסיכום קורס מיוחד ומרענן, מומלץ לכל סטודנט במנהל עסקים",
  ],
  [
    "הקורס הכי טוב שעשיתי בתואר. מרתק, מעשיר ונותן כלים פרקטיים לשימוש ביומיום שלנו — גם כמנהלים וגם בחיים האישיים.",
    "אהבתי מאוד שהמשימות ניתנו בשלבים עם התקדמות הקורס. זה סייע להפנים את הנושאים שדיברנו עליהם. אהבתי מאוד את ההשתתפות המפרה של הסטודנטים בכיתה ואת ההתייחסות ה\"מרימה\" של משה.",
    "היחס לסטודנטים היה מדהים וניתנה גמישות מאוד גדולה בכל סוגיה שהופנתה אליו. משה הוא בן אדם מעורר השראה ומדהים לראות את השליחות שלו ואת המסירות שלו בהעברת הכלים שהוא מאמין בהם הלאה.",
  ],
  [
    "המרצה היה מרתק, שילב את הנושאים התיאורטיים בצורה מאוד מעניינת. יצאתי מהקורס עם כלים פרקטיים לחיים.",
    "הקורס היה מאורגן וידוע מראש מה אנחנו צריכים לבצע בין כל מפגש ומפגש.",
  ],
  [
    "משה מרצה מדהים! הוא מגיע לתחום עם כל כך הרבה אמונה בקידום הסטודנטים.",
    "היה כיף לקחת חלק במסע הזה. הקורס הכי מומלץ הסמסטר!",
  ],
  [
    "קורס מאוד מעניין ושונה באופי שמועבר בו. סגל אקדמי מדהים עם יחס מצוין לסטודנטים.",
    "אני אישית נהניתי מהקורס ויצאתי עם המון מסקנות ונקודות עבודה. העבודות היו הוגנות ורלוונטיות. סה״כ חוויה חיובית.",
  ],
  [
    "פעם ראשונה שאני מרגישה בקורס כי הוא לטובת ההתפתחות האישית שלי לא פחות מהמקצועית. אני מרגישה שזאת לחלוטין מתנה שנתתי לעצמי לקחת את הקורס הזה.",
    "ניכר כי משה השקיע רבות בתוכן הנלמד וכי הוא בעיקר רוצה שניקח ממנו דברים פרקטיים שישפיעו על העתיד שלנו כמנהלים ובכלל.",
  ],
  "הקורס היה מעניין, גורם לחשוב ולפעול. אני חושבת שזה צריך להיות קורס חובה",
  [
    "זה הקורס היחידי בתואר (עד כה) שלקחתי שבאמת לימד אותי דברים בפרקטיקה ולא רק בתיאוריה.",
    "ההרצאות היו פעילות מאוד, ואינפורמטיביות, עם דוגמאות מהחיים האמיתיים וסיטואציות אמיתיות ואיך אפשר וצריך לפעול בכל סיטואציה.",
  ],
  [
    "העבודה בקבוצות מאוד תרמה לראות זווית אחרת של חשיבה והתמודדות. השיח והדיון הפתוח בכיתה גרמו לחוויה נעימה ושיתוף מלמד מחיי היום יום.",
    "המשימות האישיות מיקדו מאוד את ההתבוננות על היום יום ואיך אנחנו מצליחים להתפתח ולא להישאר במקום, גם במעשים הפשוטים ביותר. החזרה לשיעור וה״אימון\" במקום לאחר ההפסקה מאוד השאירו בפוקוס.",
    "באופן אישי, הקורס הוא אחד הקורסים החשובים ביותר שהיו לי בתואר. החומר הנלמד פוגש אותי כמעט בכל סיטואציה בעבודה ובבית. והיום, בזכות הקורס יש לי כלים טובים יותר להתמודדות.",
    "בנוסף, חמש הדקות שמקדישים בכל יום מפקסות אותי ו״מכריחות\" אותי לשים לעצמי יעדים, מה ששוב עוזר לי להתפתח ולא להישאר במקום. תודה!!",
  ],
  [
    "אחד הקורסים הכי משמעותיים שיצא לי ללמוד. משה אדם ומנהיג מיוחד שלגמרי השפיע עלי ולמדתי ממנו הרבה.",
    "עברתי תהליך עם הקורס הזה לגמרי ואני חושב שהקורס הזה ישאר איתי לתמיד. תודה משה",
  ],
  [
    "מטלות אשר מיישמות את החומר הנלמד, הצגת פרויקט אישי וקבוצתי מול הכיתה, נושאי לימוד מעניינים (פיתוח אישי וקולקטיבי) — בעיניי זה אחד מהקורסים הכי פרקטיים שאפשר לקחת לתחום הניהול!",
    "בנוסף, משה זמין לכל שאלה ומדבר מאוד בגובה העיניים. למרות שהיינו קבוצה גדולה, היחס הרגיש אישי והייתה התחשבות בכל נושא.",
  ],
  [
    "קורס מאוד מעניין ופרקטי. משה מרצה מדהים!!! תמיד רצה לעזור וללמד.",
    "משה לימד בצורה מדהימה, הוא נתן כלים אמיתיים ולימד דברים שבאמת יכולים לתרום לנו. הרגשתי שזה גם העצים אותי כבן אדם ופוטנציאלית כמנהלת.",
    "מעבר על החוזקות שלנו מאוד תרם לי ועזר לי להבין במה אני חזקה ולמה זה חשוב להכיר את זה. גם לשמוע ממנכ״לים זה מעניין ומלמד מאוד, וגם בכללי ההרצאות היו מעניינות ומלמדות.",
  ],
  [
    "מבחינתי היה מושלם.",
    "הייתי רוצה רק שהקורס יהיה ארוך יותר כדי שילווה אותנו לתקופה ארוכה יותר, מה שיסייע לנו להפנים וליישם טוב יותר את הכלים שלמדנו.",
  ],
  "היה קורס מצוין, לא ציפיתי לעבור קורס כזה באקדמיה, אין נקודות לשיפור. תודה רבה!",
].map((text, index) => ({
  key: `mba-feedback-${index + 1}`,
  paragraphs: Array.isArray(text) ? text : [text],
}));
